export enum OfficeLevelEnum {
    Central = 1,
    Division = 2,
    District = 3,
    Upazilla = 4,
    Union = 5
}